<template>
  <monitorsForm :typeEndPoint="'schoolRoutesMonitorsShow'" :dataParams="this.$route.params" />
</template>
<script>
import monitorsForm from '@/components/modules/schoolroutes/monitors/form'
export default {
  name: 'monitorsEdit',
  components: {
    monitorsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/monitors/edit.vue